import {ChangeDetectionStrategy, Component, effect, Injectable, input, signal, viewChild, ViewChild} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {GruppeId, GruppeRessursClient, MedlemsRolleModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeRolleRedigerListeKomponent} from "../gruppe-rolle-rediger-liste/gruppe-rolle-rediger-liste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {KortTittelKomponent} from "web-ng2/delt/komponenter/kort/kort-tittel/kort-tittel";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";

const debug = initDebugger('GruppeRollerKomponent');

@Component({
    selector: 'gruppe-roller',
    templateUrl: 'gruppe-roller.html',
    styleUrl: 'gruppe-roller.scss',
    host: { 'data-testid': 'roller' },
    imports: [
        GruppeRolleRedigerListeKomponent,
        MatButtonModule,
        TranslateModule,
        MatIcon,
        KortKomponent,
        KortTittelKomponent,
        KortHandlingerKomponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeRollerKomponent {

    kortKomp = viewChild.required(KortKomponent);

    gruppeId = input.required<GruppeId>();

    roller = signal<MedlemsRolleModell[]>([]);
    visning = signal(true);

    constructor(private avhengigheter: GruppeRollerKomponentAvhengigheter) {
        effect(() => {
            debug('laster roller for', this.gruppeId());
            this.avhengigheter.hentRoller(this.gruppeId())
              .then(r => this.roller.set(r));
        });
    }

    visDetaljer() {
        this.kortKomp().setSomAktivOgSkrollTil();
    }

    skjulDetaljer() {
        this.kortKomp().setSomIkkeAktiv();
    }

    rediger() {
        this.visning.set(false);
    }

    redigeringFerdig(oppdaterteRoller: MedlemsRolleModell[] | null) {
        if (oppdaterteRoller !== null)
            this.roller.set(oppdaterteRoller);
        this.visning.set(true);
        this.kortKomp().skrollTil();
    }
}

@Injectable()
export class GruppeRollerKomponentAvhengigheter {

    constructor(private gruppeRessurs: GruppeRessursClient) {
    }

    hentRoller(gruppeId: GruppeId): Promise<MedlemsRolleModell[]> {
        return this.gruppeRessurs.finnTilgjengeligeRoller(gruppeId).somPromise();
    }
}
